import dayjs from 'dayjs';

const DAY_MAP = {
  0: 'SUNDAY',
  1: 'MONDAY',
  2: 'TUESDAY',
  3: 'WEDNESDAY',
  4: 'THURSDAY',
  5: 'FRIDAY',
  6: 'SATURDAY'
};

const SHORT_DAY_MAP = {
  0: 'SUN',
  1: 'MON',
  2: 'TUE',
  3: 'WED',
  4: 'THU',
  5: 'FRI',
  6: 'SAT'
};

const MONTH_MAP = {
  0: {
    short: 'JAN',
    long: 'JANUARY'
  },
  1: {
    short: 'FEB',
    long: 'FEBRUARY'
  },
  2: {
    short: 'MAR',
    long: 'MARCH'
  },
  3: {
    short: 'APR',
    long: 'APRIL'
  },
  4: {
    short: 'JAN',
    long: 'JANUARY'
  },
  5: {
    short: 'MAY',
    long: 'MAY'
  },
  6: {
    short: 'JUN',
    long: 'JUNE'
  },
  7: {
    short: 'AUG',
    long: 'AUGUST'
  },
  8: {
    short: 'SEP',
    long: 'SEPTEMBER'
  },
  9: {
    short: 'OCT',
    long: 'OCTOBER'
  },
  10: {
    short: 'NOV',
    long: 'NOVEMBER'
  },
  11: {
    short: 'DEC',
    long: 'DECEMBER'
  }
};

const getDayDetails = (inputDate) => {
  const date = dayjs(inputDate).format('YYYY-MM-DD');
  const day = DAY_MAP?.[dayjs(inputDate).day()];
  const number = dayjs(inputDate).date();
  const shortDay = SHORT_DAY_MAP?.[dayjs(inputDate).day()];
  const isToday = dayjs(dayjs(inputDate).format('YYYY-MM-DD')).isSame(
    dayjs().format('YYYY-MM-DD')
  );
  const month = MONTH_MAP?.[dayjs(inputDate).month()];
  const year = dayjs(inputDate).year();

  const IsoDate = dayjs(inputDate).format('YYYY-MM-DDTHH:mm');
  const startTime = dayjs(inputDate)
    .startOf('day')
    .format('YYYY-MM-DDTHH:mm:ss.SSS');

  const endTime = dayjs(inputDate)
    .endOf('day')
    .format('YYYY-MM-DDTHH:mm:ss.SSS');

  return {
    date,
    day,
    number,
    shortDay,
    isToday,
    shortMonth: month?.short,
    longMonth: month?.long,
    year,
    IsoDate,
    startTime,
    endTime
  };
};

const scrollToCurrentTime = () => {
  const element = document.getElementsByClassName(
    'rbc-current-time-indicator'
  )?.[0];
  if (element) {
    element.scrollIntoView();
  }
};

const getFormattedStartAndEndTime = (start, end, selected) => {
  const startDate = dayjs(start).format('YYYY-MM-DD');
  const endDate = dayjs(end).format('YYYY-MM-DD');
  const selectedDate = dayjs(selected).format('YYYY-MM-DD');

  const dayDetails = getDayDetails(selectedDate);

  if (startDate !== endDate) {
    if (selectedDate === startDate) {
      return {
        start: new Date(start),
        end: new Date(dayDetails?.endTime)
      };
    } else if (selectedDate === endDate) {
      return {
        start: new Date(dayDetails?.startTime),
        end: new Date(end)
      };
    } else {
      return {
        start: new Date(dayDetails?.startTime),
        end: new Date(dayDetails?.endTime)
      };
    }
  } else {
    return {
      start: new Date(start),
      end: new Date(end)
    };
  }
};

export { getDayDetails, scrollToCurrentTime, getFormattedStartAndEndTime };
